var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.templateSelectorDialog.visible
        ? _c("cargo-template-selector-dialog", {
            attrs: {
              visible: _vm.templateSelectorDialog.visible,
              "template-uuids": _vm.templateSelectorDialog.templateUuids,
              "document-type-uuid": _vm.templateSelectorDialog.documentTypeUuid,
              lob: _vm.templateSelectorDialog.lob,
              job: _vm.templateSelectorDialog.job,
              data: _vm.templateSelectorDialog.data,
              "job-uuid-list": _vm.templateSelectorDialog.jobUuidList,
              "call-by-instruction": true
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
              },
              instructionCallback: _vm.instructionCallback
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }